<template>
  <el-timeline
    v-if="events.length > 0"
    class="p-2"
  >
    <el-timeline-item
      v-for="(event, index) in events"
      :key="event.id"
      :timestamp="$moment(event.created_at).format('DD/MM/YYYY hh:mm a')"
      :type="getEventTimelineItemType(event)"
      :class="{ 'p-0': index === (events.length - 1), 'pt-1': index === 0 }"
    >
      <b>{{ event.type | titleize }}</b><br>
      {{ $_.get((event.account || event.team || event.profile || event.branch), 'label', '') }}
    </el-timeline-item>
  </el-timeline>

  <p
    v-else
    v-loading="isLoading"
    class="text-center text-muted py-3"
  >
    No Data
  </p>
</template>

<script>
import { TYPE_ALLOCATE, TYPE_RETURN, TYPE_WARRANTY, TYPE_CREATED, TYPE_BROKEN } from '@/plugins/sdk/resources/Asset/Event'

export default {
  props: {
    asset: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isLoading: false,
      events: []
    }
  },
  mounted () {
    const asset = this.asset.clone()
    let events = []

    if (asset.events.length > 0) {
      events = asset.$fields.events.copy()
    } else {
      // @todo go fetch my car
    }

    events.sort((first, second) => {
      return new Date(second.created_at) - new Date(first.created_at)
    })

    this.events = events
  },
  methods: {
    getEventTimelineItemType (event) {
      switch (event.type) {
        case TYPE_ALLOCATE:
          return 'info'
        case TYPE_RETURN:
        case TYPE_CREATED:
          return 'success'
        case TYPE_WARRANTY:
          return 'warning'
        case TYPE_BROKEN:
          return 'danger'
        default:
          return 'default'
      }
    }
  }
}
</script>
